$(function($) {
    // Add more custom jquery here
    $('#scrollTop').on('click', function() {
        var body = $("html, body");
        body.stop().animate({scrollTop:0}, 500, 'swing', function() {});
    });

    $(window).on('scroll', function () {
        if ($(window).scrollTop() + $(window).height() < $(document).height()) {
            $('#scrollTop').removeClass('invisible');
        }

        if ($(window).scrollTop() == 0) {
            $('#scrollTop').addClass('invisible');
        }
    });
});
